import { ReactElement } from 'react';

import { Skeleton } from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

export function CategoriesSkeleton(): ReactElement {
  return (
    <div className={styles.block}>
      <Skeleton radius={12} height={32} width={49}/>
      <Skeleton radius={12} height={32} width={104}/>
      <Skeleton radius={12} height={32} width={104}/>
      <Skeleton radius={12} height={32} width={88}/>
    </div>
  );
}
